import React, { useEffect } from "react";
import { Drawer, Form } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import style from "./index.module.less";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const AntDrawer = ({
  visible,
  onClose,
  children,
  heading,
  button,
  size,
  onFinish,
  onFinishFailed,
  form,
  initialValues,
}) => {
  return (
    <div className={style.DrawerWrapper}>
      <Drawer
        destroyOnClose
        size={size ? size : "large"}
        closeIcon={<CloseCircleFilled />}
        title={heading}
        placement="right"
        onClose={onClose}
        visible={visible}
        closable
        className={style.mainDrawer}
        // width="100%"
      >
        <PerfectScrollbar className={style.scrollbarWrapper}>
          <Form
            requiredMark={false}
            form={form}
            layout="vertical"
            autoComplete="off"
            className={style.formBody}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={initialValues}
          >
            {children}

            {button}
          </Form>
        </PerfectScrollbar>
      </Drawer>
    </div>
  );
};
export default AntDrawer;
